<template lang="html">
    <div>
        <div v-if="loading">
            <div style="text-align:center">
                <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <div v-if="loading == false">
            <div class="box">
                <div class="box-body" style="padding: 8px;">
                    <div class="row">
                        <div class="col-md-3">
                            <select2 name="Arama Durumu"
                                     :data="callStatuses"
                                     :selected="filters.callStatus"
                                     :maxSelection="1"
                                     v-on:onChange="onCallStatusChanged" />
                        </div>
                        <div class="col-md-6"></div>
                        <div class="col-md-3">
                            <div class="float-lg-right">
                                <daterange :dateRange="filters.dateRange" v-on:onChange="onDateFilterChanged" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <autoupdate :loading="reportDataLoading" v-on:refreshData="loadData" />
            <div class="box">
                <div class="box-header" style="padding-top: 3px; padding-bottom:3px;">&nbsp;</div>
                <div class="box-tool" style="top: 4px;">
                    <ul class="nav">
                        <li class="nav-item inline">
                            <a class="nav-link" v-on:click="downloadCsv"><span class="fa fa-download"></span></a>
                        </li>
                    </ul>
                </div>
                <table2 :rows="data" :headers="getTableHeaders()" :hasTotalRow="true" />
            </div>
        </div>
    </div>
</template>

<script>
    import Select2 from '../../../components/select.v2.vue';
    import DateRange from '../../../components/daterange.vue';
    import AutoUpdate from '../../../components/auto_update.vue';
    import moment from 'moment';
    import Table2 from '../../../components/table.v2.vue';
    import TimezoneChangeMixin from '../../../mixins/timezone-change.vue';

    export default {
        mixins: [TimezoneChangeMixin],
        components: {
            'select2': Select2,
            'daterange': DateRange,
            'autoupdate': AutoUpdate,
            'table2': Table2
        },
        data: function () {
            return {
                filters: {
                    callStatus: [],
                    dateRange: [moment(), moment()]
                },
                callStatuses: [
                    {
                        id: 'missed',
                        text: 'Missed'
                    },
                    {
                        id: 'answered',
                        text: 'Answered'
                    },
                    {
                        id: 'rejected',
                        text: 'Rejected'
                    }
                ],
                data: [],
                loading: false,
                reportDataLoading: false,
                csvDownloadUrl: ''
            }
        },
        mounted: function () {
            this.loading = false;
            this.loadData();
        },
        methods: {
            loadData: function () {
                this.reportDataLoading = true;
                var $this = this;
                var params = {
                    id: this.$router.currentRoute.query.id,
                    call_status: this.filters.callStatus,
                    start_date: this.filters.dateRange[0].format('YYYY-MM-DD 00:00:00'),
                    end_date: this.filters.dateRange[1].format('YYYY-MM-DD 23:59:59')
                };
                this.$app.get('/api/v1/dashboards/report/getcontact/call-history-data', params, function(xhr) {
                    $this.reportDataLoading = false;
                    var response = xhr.responseJSON;
                    $this.data = response.data;
                    params.access_token = $this.$app.getAccessToken();
                    params.csv = 1;
                    $this.csvDownloadUrl = '/api/v1/dashboards/report/getcontact/call-history-data?' + $.param(params);
                }, {'Timezone': this.$app.getTimezone()});
            },
            formatDate: function (date) {
                return moment(date, 'YYYY-MM-DD').format('DD.MM.YYYY');
            },
            downloadCsv: function () {
                if (this.csvDownloadUrl !== '') {
                    window.open(this.csvDownloadUrl);
                }
            },
            onDateFilterChanged: function (data) {
                this.filters.dateRange = data;
                this.loadData();
            },
            onCallStatusChanged: function (data) {
                this.filters.callStatus = data;
                this.loadData();
            },
            getTableHeaders: function () {
                var headers = [
                    {
                        columnName: 'country',
                        title: 'Ülke',
                        dataFormat: 'string'
                    },
                    {
                        columnName: 'in_direction',
                        title: 'Gelen Arama',
                        dataFormat: 'integer',
                        valueFormat: 'integer'
                    },
                    {
                        columnName: 'out_direction',
                        title: 'Giden Arama',
                        dataFormat: 'integer',
                        valueFormat: 'integer'
                    },
                    {
                        columnName: 'avg_duration',
                        title: 'Ortalama Konuşma Süresi',
                        dataFormat: 'integer',
                        regex: "[0-9]+"
                    }
                ];
                if (this.filters.callStatus.length > 0 && headers.length > 3) {
                    headers.splice(2, 1);
                }
                return headers;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// call_history.vue?3d31c678